// libs
import React, { useState, useRef } from 'react';
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/form.css";
import "react-datepicker/dist/react-datepicker.css";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
// components 
import Loading from '../../components/loading';
// config & functions 
import ajaxCall from '../../utils/ajaxcall';
import config from "../../config/index";
import { formatSizeLabel } from '../../utils/size-label';
import { parseApiRecords } from '../../utils/parse-api-records';

function VariantModal({loadapidata, apidataparams, setshowvariantmodalbox, rowid, token, orginfo}) {

    const [InputFields, setInputFields] = useState({
        accountId: "",
        statusId: "",
        skuId: "",
        colorId: "",
        sizeId: "",
        quantity: "",
        mrp: "",
        listingPrice: ""
    });
    const ppId = (rowid && rowid.ppid) ? rowid.ppid : 0;
    const pvId = (rowid && rowid.pvid) ? rowid.pvid : 0;
    const wrapperRef = useRef(null);
    const [SubmitButton, setSubmitButton] = useState((rowid) ? 'UPDATE RECORD' : 'SAVE RECORD');
    const [Notification, setNotification] = useState({ status: (rowid) ? true : false, message: 'Please wait while we fetch your record' })
    const [DisableSubmitButton, setDisableSubmitButton] = useState(false);
    const [AccountNames, setAccountNames] = useState(null);
    const [ColorList, setColorList] = useState([]);
    const [SizeList, setSizeList] = useState([]);
    const [StatusList, setStatusList] = useState([]);
    const [Show, setShow] = useState(false);

    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
        reset
    } = useForm();

    const hideModal = () => {
        setShow(false);
        setshowvariantmodalbox(false)
	}

    const updateChangeEvent = (value, field) => {
		field.onChange(value);
	}

    const onSubmit = async (data) => {
        setSubmitButton('LOADING...');
        setDisableSubmitButton(true);
        let apiCall = "";
        if (rowid && rowid.action === "edit") {
            let postData = {
                accountId: InputFields.accountId, 
                statusId: data.statusId,
                ppId: ppId,
                pvId: pvId,
                quantity: data.quantity,
                mrp: data.mrp,
                listingPrice: data.listingPrice
            }
            apiCall = await ajaxCall.patchCall(`${config.api.generic}/inventory/variant/update`, postData, token);
        } else if (rowid && rowid.action === "addNew") {
            let postData = {
                accountId: InputFields.accountId,
                statusId: data.statusId,
                ppId: ppId,
                skuId: data.skuId,
                colorId: data.colorId,
                sizeId: data.sizeId,
                quantity: data.quantity,
                mrp: data.mrp,
                listingPrice: data.listingPrice
            }
            apiCall = await ajaxCall.postCall(`${config.api.generic}/inventory/variant/add`, postData, token);
        }
        if(apiCall && apiCall.status) {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.info('Record updated successfully');
            reset();
            setDisableSubmitButton(false);
            loadapidata(apidataparams); // refresh list page
        } else {
            setSubmitButton((InputFields.rowId)?'UPDATE RECORD':'SAVE RECORD');
            toast.error(apiCall && apiCall.context.message || 'Something went wrong. Please try again :(');
            setDisableSubmitButton(false);
        }
    }
    
    const fetchColorList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/color`, {}, token);
        if (apiCall && apiCall.status) {
            setColorList(parseApiRecords(apiCall));
        } else {
            setColorList([]);
        }
    }

    const fetchSizeList = async (accountId) => {
        if (!accountId) {
            setSizeList([]);
            return;
        }
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/size`, { fAccount: accountId }, token);
        if (apiCall && apiCall.status && apiCall.context.message.data?.records) {
            setSizeList(apiCall.context.message.data.records);
        } else {
            setSizeList([]);
        }
    }

    const fetchStatusList = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory/status`, {}, token);
        if(apiCall && apiCall.status) {
            setStatusList(apiCall.context.message.data);
        }
    }

    const fetchAccountNames = async () => {
        let apiCall = await ajaxCall.getCall(`${config.api.generic}/account/get-names`, {}, token);
        if(apiCall && apiCall.status) {
            setAccountNames(apiCall.context.message.data);
        } else {
            setAccountNames("Something went wrong. Please try agian")
        }
    }
    // Get data from DB - Used for Edit option
    React.useEffect(() => {
        async function loadComponent() {
            setShow(true);
        }

        async function fetchData() {
            // Used in edit
            if (rowid && rowid.action === "edit") {
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory/variant/row`, {action: "edit", ppId, pvId}, token);
                if(apiCall && apiCall.status) {
                    let onLoadData = {
                        accountId: apiCall.context.message.data[0].fk_org_account_id,
                        productName: apiCall.context.message.data[0].product_name,
                        statusId: apiCall.context.message.data[0].fk_inventory_status_id,
                        skuId: apiCall.context.message.data[0].skuid,
                        colorId: apiCall.context.message.data[0].fk_color_id,
                        sizeId: apiCall.context.message.data[0].fk_size_id,
                        quantity: apiCall.context.message.data[0].quantity,
                        mrp: apiCall.context.message.data[0].mrp,
                        listingPrice: apiCall.context.message.data[0].listing_price,
                    }
                    setInputFields(onLoadData)
                    setNotification({ status: false })
                    fetchSizeList(onLoadData.accountId);
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' })
                }
            } else if (rowid && rowid.action === "addNew") {
                // Used in new entry
                let apiCall = await ajaxCall.getCall(`${config.api.generic}/inventory/variant/row`, {action: "addNew", ppId }, token);
                if(apiCall && apiCall.status) {
                    let onLoadData = {
                        accountId: apiCall.context.message.data[0].fk_org_account_id,
                        productName: apiCall.context.message.data[0].product_name,
                        statusId: apiCall.context.message.data[0].fk_inventory_status_id,
                        skuId: "",
                        colorId: "",
                        sizeId: "",
                        quantity: "",
                        mrp: "",
                        listingPrice: "",
                    }
                    setInputFields(onLoadData)
                    setNotification({ status: false })
                    fetchSizeList(onLoadData.accountId);
                } else {
                    setNotification({ status: true, message: 'Sorry something went wrong while fetching record :(' })
                }
            }
        }
        fetchAccountNames();
        fetchData();
        fetchColorList();
        fetchStatusList();
        loadComponent();
    }, []);

    let operation = 'add';
    if (typeof rowid === "object" && rowid.hasOwnProperty('ppid') && rowid.hasOwnProperty('pvid')) {
        operation = 'update';
    }

    return (
        <>
            <Modal show={Show} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Header>
                    <Modal.Title>Add Inventory Variant</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <form action="" method="" className="p-sm-1" onSubmit={handleSubmit(onSubmit)}>
                                <Row>
                                    {(Notification.status) ? <Col md="12" className="text-center">{Notification.message}</Col> : <>
                                        <Col md="12">
                                            <div className="text-left mt-3 vt-txt-dark-blue">
                                                <h4><b>Add Variant</b></h4>
                                                <hr />
                                            </div>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Choose Client</label>
                                            {(AccountNames && Array.isArray(AccountNames) && AccountNames.length > 0) ? <><Controller
                                                name='accountId' 
                                                defaultValue={InputFields.accountId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="accountId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={true}>
                                                        <option value=""> Choose...</option>
                                                        {AccountNames.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        })}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.accountId?.type === "required" && "Please choose Client"}
                                            </small></> : (AccountNames === null) ? <Loading margin={1} /> : <div className="text-danger fs-12rem">{AccountNames}</div> }
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Status</label>
                                            <Controller
                                                name='statusId' 
                                                defaultValue={InputFields.statusId}
                                                rules={{required: true}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="statusId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={false}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(StatusList) && StatusList.length > 0) ? StatusList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.statusId?.type === "required" && "Please update status"}
                                            </small>
                                        </Col>
                                        <Col md="12" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Product Name</label>
                                            <input type="text" defaultValue={InputFields.productName} className="form-control" name="productName" {...register("productName", { required: false, minLength: 1, maxLength: 122 })} disabled={true} />
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "required" && "Product Name is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.productName?.type === "maxLength" && "Only 122 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Color</label>
                                            <Controller
                                                name='colorId' 
                                                defaultValue={InputFields.colorId}
                                                rules={{required: false}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="colorId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={(rowid && rowid.action === "addNew")?false:true}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(ColorList) && ColorList.length > 0) ? ColorList.map(d => {
                                                            return <option key={Math.random()} value={d.pk_id}>{d.label}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.colorId?.type === "required" && "Please update color"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Size</label>
                                            <Controller
                                                name='sizeId' 
                                                defaultValue={InputFields.sizeId}
                                                rules={{required: false}}
                                                control={control} 
                                                render={({field}) => (
                                                    <select value={field.value || ""} className="form-control custom-select" name="sizeId" onChange={(e) => {updateChangeEvent(e, field)}} disabled={(rowid && rowid.action === "addNew")?false:true}>
                                                        <option value=""> Choose...</option>
                                                        {(Array.isArray(SizeList) && SizeList.length > 0) ? SizeList.map(d => {
                                                            return <option key={d.pk_id} value={d.pk_id}>{formatSizeLabel(d)}</option>
                                                        }):null}
                                                    </select>
                                                )}
                                            />	
                                            <small className="form-text text-danger">
                                                {errors.sizeId?.type === "required" && "Please update size"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">SKU Id</label>
                                            <input type="text" defaultValue={InputFields.skuId} className="form-control" name="skuId" {...register("skuId", { required: true, minLength: 1, maxLength: 125 })} disabled={(rowid && rowid.action === "addNew")?false:true} />
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "required" && "Sku Id is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.skuId?.type === "maxLength" && "Only 125 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Quantity</label>
                                            <input type="text" defaultValue={InputFields.quantity} className="form-control" name="quantity" {...register("quantity", { required: true, minLength: 1, maxLength: 7 })} disabled={false} />
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "required" && "Quantity is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.quantity?.type === "maxLength" && "Only 7 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">MRP</label>
                                            <input type="text" defaultValue={InputFields.mrp} className="form-control" name="mrp" {...register("mrp", { required: true, minLength: 1, maxLength: 5 })} disabled={false} />
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "required" && "MRP is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.mrp?.type === "maxLength" && "Only 5 characters allowed"}
                                            </small>
                                        </Col>
                                        <Col md="4" className="mt-3">
                                            <label className="form-label fs-14rem fw-bold">Listing Price</label>
                                            <input type="text" defaultValue={InputFields.listingPrice} className="form-control" name="listingPrice" {...register("listingPrice", { required: true, minLength: 1, maxLength: 5 })} disabled={false} />
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "required" && "Listing price is mandatory"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "minLength" && "Enter atleast 1 characters"}
                                            </small>
                                            <small className="form-text text-danger">
                                                {errors.listingPrice?.type === "maxLength" && "Only 5 characters allowed"}
                                            </small>
                                        </Col>
                                        {(orginfo.roleId === 1 || orginfo.roleId === 2) ? <Col md="12" className="text-end">
                                            <Button variant="primary" type="submit" disabled={DisableSubmitButton} className="vt-primary-btn text-end btn-lg border-0 text-white btn mt-4 fs-14rem">{SubmitButton}</Button>
                                        </Col> : null }
                                    </>}
                                </Row>
                            </form>
                        </Row>
                    </Container>
                </Modal.Body>
                <div className="modal-footer">
                    <Button variant="primary" type="button" className="btn btn-secondary fs-14rem" onClick={hideModal}>Close</Button>
                </div>
            </Modal>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    )
}

export default VariantModal;